import { DataModel, DataModelBuilder, SerializationContext, SerializedData, isSameData } from '../../dto/dto.js';
import { MapUtils } from '../../../utility/map-utils.js';
import { PromoCodeProtocol, PromoCodeProtocolType } from './promo-code-protocol.js';
import { Price } from '../price.js';

export class FixedPromoCodeProtocol extends PromoCodeProtocol {
  static readonly TYPE_ID: string = '05a550a472df440aa4388c35cf6378ee';

  public readonly type: PromoCodeProtocolType = PromoCodeProtocolType.Fixed;

  constructor(
    public readonly price: Price,
  ) {
    super();
  }

  get $typeId(): string {
    return FixedPromoCodeProtocol.TYPE_ID;
  }

  static fromMap(context: SerializationContext, map: SerializedData): FixedPromoCodeProtocol {
    return new FixedPromoCodeProtocol(
        Price.decode(MapUtils.get<string>(map, 'price')),
    );
  }

  toMap(context: SerializationContext): SerializedData {
    return {
      'price': this.price.encode(),
    };
  }

  clone(): this {
    return new FixedPromoCodeProtocol(
        this.price.clone(),
    ) as this;
  }

  isSame(other: FixedPromoCodeProtocol): boolean {
    if(this === other) {
      return true;
    }

    return isSameData(other.price, this.price);
  }

  calculateDiscount(originalPrice: Price): Price {
    if(originalPrice.currency != this.price.currency) {
      return Price.zero(originalPrice.currency);
    }

    const value = Math.max(0, Math.min(originalPrice.value, this.price.value));
    return Price.withCurrencyFromUnits(originalPrice.currency, value);
  }

  static verifyType(dm: DataModel): boolean {
    return dm instanceof FixedPromoCodeProtocol;
  }

  static assertType(dm: DataModel): dm is FixedPromoCodeProtocol {
    return dm instanceof FixedPromoCodeProtocol;
  }
}

export class FixedPromoCodeProtocolBuilder extends DataModelBuilder<FixedPromoCodeProtocol> {
  build(context: SerializationContext, map: SerializedData): FixedPromoCodeProtocol {
    return FixedPromoCodeProtocol.fromMap(context, map);
  }
}
